import { qs } from "url-parse";
import { useEffect } from "react";
import { addPrefix } from "../utils/WithQs";

export default function useSyncSearch(history, location, data) {
  const watch = data.map(d => d[0]);

  useEffect(() => {
    console.log("sync search");

    const fullSearchData = qs.parse(location.search);

    data.forEach(([d, p]) => {
      const prefixParams = addPrefix(d, p);
      Object.assign(fullSearchData, prefixParams);
    });

    const filteredSearch = {};
    Object.keys(fullSearchData).forEach(key => {
      if (fullSearchData[key] != undefined && fullSearchData[key] != "") {
        filteredSearch[key] = fullSearchData[key];
      }
    });

    const s = qs.stringify(filteredSearch);
    history.push({ search: "?" + s });
  }, watch);
}
